module.exports = __webpack_public_path__ + "static/media/play-btn.780059d9.svg";